module.exports = __webpack_public_path__ + "img/Metal_Roof.787e5787.jpg";